var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4045 15.5716C28.9514 15.2559 28.3281 15.3674 28.0124 15.8206L26.8355 17.5101L31.2282 20.57L32.4052 18.8804C32.7208 18.4272 32.6094 17.804 32.1562 17.4883L29.4045 15.5716ZM25.9609 18.7658L30.3536 21.8257L23.3597 31.8663L19.1962 33.1602L18.9669 28.8064L25.9609 18.7658Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.906ffd8166c118c23d5b21ed89c3ad3c.svg";
export { ForwardRef as ReactComponent };